import { temAcesso } from '@/shared/auth/temAcesso'

const Contratos = () => import('./Contratos.vue')
const ContratoDetalhar = () => import('./ContratoDetalhar.vue')

export default {
    path: 'contratos',
    name: 'Gescon_Apoios_Contratos',
    component: Contratos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-APOIO-CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: ':contratoId',
            name: 'Gescon_Apoios_Contratos_Detalhar',
            component: ContratoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-APOIO-CONT-00')) {
                    next()
                }
            }
        }
    ]
}
